import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import omit from 'lodash/omit';
import {
  Button, Divider, IconButton, Menu, MenuItem, ListItemIcon, ListItemText, ListItemSecondaryAction,
} from '@material-ui/core';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import ArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import _ from 'lodash';

import { createChart } from '../../../../events';
import * as actions from '../../../../state';
import styles from '../styles.module.css';

const messages = defineMessages({
  COPY: {
    id: 'COPY',
    defaultMessage: 'Copy',
  },
  COPY_CHART: {
    id: 'COPY_CHART',
    defaultMessage: 'Copy chart',
  },
  COPY_CHART_TO: {
    id: 'COPY_CHART_TO',
    defaultMessage: 'Copy chart to...',
  },
  CHART_COPIED: {
    id: 'CHART_COPIED',
    defaultMessage: 'Chart copied.',
  },
  NEW_CHART: {
    id: 'NEW_CHART',
    defaultMessage: 'New chart',
  },
  THIS_BOARD: {
    id: 'THIS_BOARD',
    defaultMessage: 'This board',
  },
  CONFIRM_BACK_MSG: {
    id: 'CONFIRM_BACK_MSG',
    defaultMessage: 'Going back will discard your unsaved changes. Are you sure?',
  },
  BACK_TOOLTIP: {
    id: 'BACK_TOOLTIP',
    defaultMessage: 'Finish editing and return to the board',
  },
  BACK: {
    id: 'BACK',
    defaultMessage: 'Back',
  },
  CONFIRM: {
    id: 'CONFIRM',
    defaultMessage: 'Confirm',
  },
});

function CopyChart({
  chartToCopy,
  dense,
  intl,
  variant,
}) {
  const dispatch = useDispatch();

  const user = useSelector(actions.readStateUser);
  const board = useSelector(actions.readStateBoard);
  const boardList = useSelector(actions.readStateBoardList);

  const [anchorEl, setAnchorEl] = useState();
  const [menuAnchorEl, setMenuAnchorEl] = useState();

  const handleClick = (e) => {
    setAnchorEl(e.currentTarget);
    setMenuAnchorEl(e.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setMenuAnchorEl(null);
  };

  const copyChart = (dashboardId) => {
    const newChart = omit(chartToCopy, ['id']);

    let selectedLayout;
    board?.layouts?.lg?.forEach((gridItem) => { // search the layout for the old id, swap it
      if (_.toString(gridItem.i) === _.toString(chartToCopy.id)) {
        selectedLayout = gridItem;
      }
    });

    dispatch(createChart(
      _.cloneDeep(newChart),
      selectedLayout.h,
      selectedLayout.w,
      dashboardId,
      intl,
      messages,
    ));

    handleClose();
  };

  const myBoards = boardList.filter((b) => String(b.owner_id) === String(user.userId));

  return (
    <>
      {dense && (
        <IconButton
          aria-owns={anchorEl ? 'simple-menu' : null}
          aria-haspopup="true"
          onClick={handleClick}
        >
          <FileCopyIcon />
        </IconButton>
      )}

      {!dense && variant !== 'menuItem' && (
        <Button
          aria-owns={anchorEl ? 'simple-menu' : null}
          aria-haspopup="true"
          onClick={handleClick}
          disableRipple
          className={styles.kebabButton}
          classes={{ label: styles.kebabLabel }}
        >
          <FileCopyIcon />
          <FormattedMessage {...messages.COPY_CHART} />
        </Button>
      )}

      {variant === 'menuItem' && (
        <MenuItem
          aria-owns={anchorEl ? 'simple-menu' : null}
          aria-haspopup="true"
          onClick={handleClick}
          className={styles.menuIcons}
        >
          <ListItemIcon>
            <FileCopyIcon className={styles.menuIcons} />
          </ListItemIcon>

          <ListItemText primary={<FormattedMessage {...messages.COPY} />} />

          <ListItemSecondaryAction style={{ marginTop: 2, color: 'rgba(0, 0, 0, 0.45)', pointerEvents: 'none' }}>
            <ArrowRightIcon className={styles.menuIcons} />
          </ListItemSecondaryAction>
        </MenuItem>
      )}

      <Menu
        id="simple-menu"
        anchorEl={menuAnchorEl}
        open={Boolean(menuAnchorEl)}
        onClose={handleClose}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        classes={{ paper: styles.boardSelectPaper }}
      >
        <MenuItem key={0} disabled>
          <FormattedMessage {...messages.COPY_CHART_TO} style={{ color: 'rgba(0, 0, 0, 0.58)' }} />
        </MenuItem>
        <MenuItem key={board.id} onClick={() => copyChart(board.id)} style={{ fontWeight: 800 }}>
          <FormattedMessage {...messages.THIS_BOARD} />
        </MenuItem>

        <Divider style={{ margin: '7px 0' }} />

        {myBoards.filter((fBoard) => fBoard.id !== board.id).map((mBoard) => (
          <MenuItem key={mBoard.id} onClick={() => copyChart(mBoard.id)}>
            {mBoard.name}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

export default injectIntl(CopyChart);
